import * as React from 'react';

// @mui material components
import Grid from "@mui/material/Grid";

// Material Dashboard 2 React components
import MDBox from "components/MDBox";

// Material Dashboard 2 React example components
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import useApi from "../../../components/Utils/api";
import { useNavigate } from "react-router-dom";
import {QontoConnector, QontoStepIcon, ColorlibConnector, ColorlibStepIcon} from "./stepper";
import Stack from '@mui/material/Stack';
import Stepper from '@mui/material/Stepper';
import Step from '@mui/material/Step';
import StepLabel from '@mui/material/StepLabel';
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import { StepContent } from "@mui/material";
import MerchantOfficeDetails from "../tabs/merchantOffficeDetails";
import MerchantBankDetails from "../tabs/merchantBankDetails";
import MerchantOtherDetails from "../tabs/merchantOtherDetails";
import { useContext } from "react";
import ValidationContext from "../../../context/validation";
import { merchantSchemaStep1, merchantSchemaStep2, merchantSchemaStep3 } from "../../../models/merchantModel";
import { FormProvider, useForm } from "react-hook-form";
import { yupResolver } from '@hookform/resolvers/yup';
import toast from "react-hot-toast";
import {useTranslation} from "react-i18next";
import FormControl from "@mui/material/FormControl";
import InputLabel from "@mui/material/InputLabel";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import Chip from "@mui/material/Chip";


function NewMerchant() {
  const navigate = useNavigate();
  const {t} = useTranslation();

  const api = useApi();
  const [activeStep, setActiveStep] = React.useState(0);
  const [routes, setRoutes] = React.useState([]);
  const [selectedRouteId, setSelectedRouteId] = React.useState("");

  // Derived: is the selected route EXTERNAL?
  const selectedRoute = routes.find(r => r.id === selectedRouteId);
  const isExternalRoute = selectedRoute?.settlementMode === "EXTERNAL";

  const { register, handleSubmit, reset, formState: { errors }, trigger, watch, control, setValue } = useForm({
    mode: "onChange",
    resolver: yupResolver(
      activeStep === 0 ? merchantSchemaStep1
        : activeStep === 1 ? (isExternalRoute ? {} : merchantSchemaStep2)
        : activeStep === 2 ? merchantSchemaStep3
        : {}
    )
  });
  const [merchant, setMerchant] = React.useState({ merchantFiles: []});
  const [requiredInfo, setRequiredInfo] = React.useState({
    mcclist : [],
    cityList : [],
    referenceCompany : [],
    microAtm : []
  })

  const onSubmit = data => {
    console.log(activeStep);
    if(activeStep < 2 && Object.keys(errors).length === 0) {
      setActiveStep((prevActiveStep) => prevActiveStep + 1);
    } else {
      saveMerchant(data);
    }
  };
  const assignRouteToMerchant = (merchantMid) => {
    if (!selectedRouteId || !merchantMid) return;
    // Find the gateway merchant UUID by MID so we can call the assignment API
    api.get("settlement-routes/merchants")
      .then(res => {
        const gwMerchants = res.data || [];
        const found = gwMerchants.find(m => m.mid === merchantMid);
        if (!found) return; // gateway not synced yet — skip silently
        return api.post("settlement-routes/assignments", {
          routeId: selectedRouteId,
          merchantIds: [found.id],
          isDefault: true,
        });
      })
      .then(() => {}) // assignment success — toast already shown elsewhere
      .catch(() => toast.error("Merchant created but route assignment failed — assign manually from Settlement Routes."));
  };

  const saveMerchant = (data) => {
    let formData = new FormData();

    // Append files
    if (data.supportingDocuments && data.supportingDocuments.length > 0) {
      data.supportingDocuments.forEach((file, index) => {
        for (let i = 0; i < file.length; i++) {
          formData.append('supportingDocuments', file[i]);
        }
      });
    }
    // For EXTERNAL routes bank details may be empty — filter out blank entries
    data.merchantBankDetails = (data.merchantBankDetails || []).filter(bankdetails => bankdetails.currency !== ""
        && bankdetails.bankName !== ""
        && bankdetails.bankCode !== ""
        && bankdetails.branch !== ""
        && bankdetails.accountNumber !== "");
    delete data.supportingDocuments;
    // Append MerchantMaster object as a JSON string
    data.mccCode = "1234";
    data.areaCode = "1234";
    formData.append('merchantMaster', JSON.stringify(data));

    api.post("merchant/create", formData)
      .then(response => {
        if(response.data.statusCodeValue === 200){
          toast.success(response.data.body.message);
          // Assign route after creation (non-blocking — navigate regardless)
          if (selectedRouteId && data.mid) {
            assignRouteToMerchant(data.mid);
          }
          navigate("/merchants/single", {
            state: {
              companyId: response.data.body.companyId
            }
          })
        } else if(response.data.statusCodeValue === 409) {
          toast.error(response.data.body);
        }
        else if(response.data.statusCodeValue === 400) {
          toast.error(response.data.body.message);
        }
      })
      .catch(error => {
        const message =
        error.response?.data?.body ||
        error.response?.data?.message ||
        "Unexpected error occurred";
    toast.error(message);
        console.log(error);
      });
  }
  const handleNext = () => {
    // When EXTERNAL route is selected and we're on the bank details step,
    // skip validation and advance immediately — bank details not required.
    if (activeStep === 1 && isExternalRoute) {
      setActiveStep(2);
      return;
    }
    handleSubmit(onSubmit)();
  };
  const formValuesHandler = (e) => {
    const {name, value} = e.target;
    validateInput('NAME_BASED', name, value);
    setMerchant({...merchant, merchant : {...merchant.merchant , [name]: value}});
  }
  const getAllRequiredInfo = () => {
    api.get("merchant/getNewMerchReqInfo")
      .then(response => {
        if(response.data.statusCodeValue === 200){
          setRequiredInfo(response.data.body);
        }
      })
      .catch(error => {
        toast.error(error);
      })
  }
  React.useEffect(() => {
    getAllRequiredInfo();
    api.get("settlement-routes")
      .then(res => setRoutes(res.data || []))
      .catch(() => {}); // non-fatal — route assignment just won't be shown
  }, [])
  const handleBack = () => {
    // console.log(activeStep);
    setActiveStep((prevActiveStep) => prevActiveStep - 1);
  };
  const steps = [
    {
      label: t('merchant_office_details'),
      component: (
        <>
          <MerchantOfficeDetails merchant={merchant} setMerchant={setMerchant} editmode={true} type="new" errors={errors} register={register}/>
          {/* Settlement Route selector — always shown in Step 1 */}
          <Box mt={3} px={1}>
            <Typography variant="subtitle2" mb={1} fontWeight="medium">Settlement Route</Typography>
            <FormControl fullWidth size="small">
              <InputLabel id="new-merchant-route-label">Settlement Route (optional)</InputLabel>
              <Select
                labelId="new-merchant-route-label"
                label="Settlement Route (optional)"
                value={selectedRouteId}
                onChange={e => setSelectedRouteId(e.target.value)}
              >
                <MenuItem value="">— Use default route —</MenuItem>
                {routes.filter(r => r.status === "ACTIVE").map(r => (
                  <MenuItem key={r.id} value={r.id}>
                    {r.name}
                    {r.settlementMode === "EXTERNAL" ? " (EXTERNAL)" : " (INTERNAL)"}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
            {isExternalRoute && (
              <Typography variant="caption" color="warning.main" display="block" mt={0.5}>
                EXTERNAL route selected — bank details will not be required in the next step.
              </Typography>
            )}
          </Box>
        </>
      )
    },
    {
      label: t('merchant_bank_details'),
      component: isExternalRoute ? (
        <Box mt={3} p={3} sx={{ background: "#fff8e1", border: "1px solid #ffe082", borderRadius: 2 }}>
          <Typography variant="subtitle1" fontWeight="medium" mb={1}>Bank Details Not Required</Typography>
          <Typography variant="body2" color="text.secondary">
            The selected settlement route <strong>{selectedRoute?.name}</strong> uses <strong>EXTERNAL</strong> settlement —
            the PSP settles payments directly to merchants. Bank account details are not required.
          </Typography>
        </Box>
      ) : (
        <MerchantBankDetails merchant={merchant} setMerchant={setMerchant} editmode={true} type="new"/>
      )
    },
    {
      label: t('other_details'),
      component: <MerchantOtherDetails merchant={merchant} setMerchant={setMerchant} editmode={true} type="new"/>
    }
  ];


  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox mt={6} mb={3}>
        <Grid container spacing={3} justifyContent="center">
          <Grid item xs={12} lg={12}>
            <Stack sx={{ width: '100%' }} spacing={4}>
              <Stepper alternativeLabel style={{ background: 'unset', boxShadow: 'unset' }} activeStep={activeStep} connector={<ColorlibConnector />}>
                {steps.map((step, index) => (
                  <Step key={step.label}>
                    <StepLabel
                      StepIconComponent={ColorlibStepIcon}
                       sx={{
                         '& .MuiStepLabel-label': {
                           color: '#504d4d !important'
                         },
                         '& .MuiStepLabel-label.Mui-active': {
                           color: '#000 !important'
                         },
                         '& .MuiStepLabel-label.Mui-completed': {
                           color: '#000 !important'
                         }
                       }}
                    >
                      {step.label}
                    </StepLabel>
                  </Step>
                ))}
              </Stepper>
            </Stack>
            <FormProvider {...{ register, handleSubmit, reset, formState: { errors }, trigger, watch, requiredInfo, control, setValue }}>
            {steps.map((step, index) => (
              <Box sx={{ p: 3 }} key={step.label} style={{ display: activeStep === index ? 'block' : 'none' }}>
                {step.component}
              </Box>
            ))}
            </FormProvider>
            <Box sx={{ display: 'flex', flexDirection: 'row', pt: 2 }}>
              <Button
                color="inherit"
                disabled={activeStep === 0}
                onClick={handleBack}
                sx={{ mr: 1 }}
              >
                {t('back')}
              </Button>
              <Box sx={{ flex: '1 1 auto' }} />
              <Button onClick={handleNext}>
                {activeStep === steps.length - 1 ? t('finish') : t('next')}
              </Button>
            </Box>
          </Grid>
        </Grid>
      </MDBox>
      <Footer />
    </DashboardLayout>
  );
}

export default NewMerchant;
